import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
    providedIn: 'root',
})
export class OAuthService {
    rootUrl = `${environment.apiUrl}/api/oauth/`;
    constructor(private http: HttpClient) {}

    Token() {
        const MethodName: string = 'token';
        const url: string = this.rootUrl + MethodName;
        return this.http.post<any>(url, {"client_id":1,"client_secret":"XttrblgUW9q7kWSJhpkmv2XuAtftQa772VJgfKYs","grant_type":"client_credentials","scope":"*"});
    }

    RefreshToken(data: any) {
        const MethodName: string = 'refresh-token';
        const url: string = this.rootUrl + MethodName;
        return this.http.post<any>(url, data );
    }
}
